
import Gutter from '@/ui-kit/components/gutter';
import Google from './providers/google';
import Facebook from './providers/facebook';
import { federatedSignIn } from '@/utils/auth';
import { StyleSizeType, StylePositionType } from '@/ui-kit/styles/enums';
import { SSOProviders } from './enums';

export default {
  name: 'AuthSSO',
  components: {
    Gutter,
    Google,
    Facebook,
  },
  data: () => ({
    SSOProviders,
    StyleSizeType,
    StylePositionType,
  }),
  methods: {
    async provider(name) {
      const { referrer = '/' } = this.$route.query;
      await federatedSignIn(name, referrer);
    },
  },
};
